const createCreatorProduct = () => {};

export default createCreatorProduct;
